export type Category = {
  id: string;
  name: string;
  en: string;
  desc: string;
  icon: string;
};

export const categories: Category[] = [
  {
    id: 'rexue',
    name: '热血',
    en: 'Action',
    desc: '燃到炸裂的战斗与成长，拳拳到肉的爽快漫画大全',
    icon: 'ri-fire-fill',
  },
  {
    id: 'lianai',
    name: '恋爱',
    en: 'Romance',
    desc: '怦然心动的甜蜜日常与青春悸动',
    icon: 'ri-heart-3-fill',
  },
  {
    id: 'xuanyi',
    name: '悬疑',
    en: 'Suspense',
    desc: '层层反转的谜案推理，烧脑悬疑漫画库',
    icon: 'ri-search-eye-fill',
  },
  {
    id: 'qihuan',
    name: '奇幻',
    en: 'Fantasy',
    desc: '山海异世、魔法与神明的瑰丽幻想世界',
    icon: 'ri-sparkling-2-fill',
  },
  {
    id: 'kehuan',
    name: '科幻',
    en: 'Sci-Fi',
    desc: '星际远征与未来科技的硬核科幻幻想',
    icon: 'ri-rocket-2-fill',
  },
  {
    id: 'gaoxiao',
    name: '搞笑',
    en: 'Comedy',
    desc: '笑到停不下来的沙雕日常与无厘头剧情',
    icon: 'ri-emotion-laugh-fill',
  },
];